// Organization Branding Configuration
import { APP_NAME } from './appConfig';

export interface OrgBrandingConfig {
  orgKey: string;
  name: string;
  tagline: string;
  primaryColor: string;
  accentColor: string;
  gradientFrom: string;
  gradientTo: string;
  logoIcon: string;
  logoText: string;
  leftPanelBg: string;
  employeeLabel: string;
  loginHeading: string;
  loginSubtext: string;
}

export const ORG_CONFIG: Record<'parallel-minds' | 'data-smith' | 'default', OrgBrandingConfig> = {
  "parallel-minds": {
    orgKey: "pm-one",
    name: "Parallel Minds",
    tagline: "Engineering Intelligence. Together.",
    primaryColor: "#6366F1",
    accentColor: "#8B5CF6",
    gradientFrom: "#4F46E5",
    gradientTo: "#7C3AED",
    logoIcon: "Brain",
    logoText: "ParallelMinds",
    leftPanelBg: "from-indigo-900 via-violet-900 to-purple-950",
    employeeLabel: "Team Member",
    loginHeading: "Welcome back to Parallel Minds",
    loginSubtext: "Sign in with your Microsoft account to continue",
  },
  "data-smith": {
    orgKey: "data-smith",
    name: "Data Smith AI",
    tagline: "Forging Data. Driving Intelligence.",
    primaryColor: "#0EA5E9",
    accentColor: "#06B6D4",
    gradientFrom: "#0369A1",
    gradientTo: "#0E7490",
    logoIcon: "Hammer",
    logoText: "DataSmith AI",
    leftPanelBg: "from-sky-900 via-cyan-900 to-teal-950",
    employeeLabel: "Craftsman",
    loginHeading: "Welcome back to Data Smith AI",
    loginSubtext: "Sign in with your Microsoft account to continue",
  },
  "default": {
    orgKey: "default",
    name: APP_NAME,
    tagline: "Empowering People. Elevating Organisations.",
    primaryColor: "#6366F1",
    accentColor: "#8B5CF6",
    gradientFrom: "#4F46E5",
    gradientTo: "#6D28D9",
    logoIcon: "Users",
    logoText: APP_NAME,
    leftPanelBg: "from-indigo-900 via-purple-900 to-violet-950",
    employeeLabel: "Employee",
    loginHeading: `Welcome back to ${APP_NAME}`,
    loginSubtext: "Sign in to your account to continue",
  }
};
